export default {
	namespaced: true,
	state: {
		token: 'pk.eyJ1IjoidGhlYW5zc2dlbiIsImEiOiJjbWNnb2xvcG0wbWp2MmpvZDEzcWRqbmNoIn0.px_SVZI8cEB95WLMkqasog'
	},
	getters: {
		'access-token': state => {
			return state.token;
		}
	}
}